import { Conduit } from '@campingvision/conduit';
import { authentication } from '../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}core`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {
  getBrandsWithDomains() {
    return conduit.get('/brands/with-domains');
  },
};



// WEBPACK FOOTER //
// ./src/services/core-service.js